import React from "react";
import "./Destinations.css"; // Custom CSS
import { Carousel } from "react-bootstrap"; // Bootstrap Carousel
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap CSS



import danakil1 from "../../Assets/Image/destinations/danakil1.jpg";
import danakil2 from "../../Assets/Image/destinations/danakil2.jpg";
import danakil3 from "../../Assets/Image/destinations/danakil3.jpg";

import ertale1 from "../../Assets/Image/destinations/ertale1.jpg";
import ertale2 from "../../Assets/Image/destinations/ertale2.jpg";
import ertale3 from "../../Assets/Image/destinations/ertale3.jpg";

import afrera1 from "../../Assets/Image/destinations/afrera1.jpg";
import afrera2 from "../../Assets/Image/destinations/afrera2.jpg";
import afrera3 from "../../Assets/Image/destinations/afrera3.jpg";

import awash1 from "../../Assets/Image/destinations/awash1.jpg";
import awash2 from "../../Assets/Image/destinations/awash2.jpg";
import awash3 from "../../Assets/Image/destinations/awash3.jpg";

import hadar1 from "../../Assets/Image/destinations/hadar1.jpg";
import hadar2 from "../../Assets/Image/destinations/hadar2.jpg";
import hadar3 from "../../Assets/Image/destinations/hadar3.jpg";

import mountayalu1 from "../../Assets/Image/destinations/mountayalu1.jpg";

import riftvally1 from "../../Assets/Image/destinations/riftvally1.jpg";

import lakeabbe1 from "../../Assets/Image/destinations/lakeabbe1.jpg";
import lakeabbe2 from "../../Assets/Image/destinations/lakeabbe2.jpg";
import lakeabbe3 from "../../Assets/Image/destinations/lakeabbe3.jpg";

import Yangudi1 from "../../Assets/Image/destinations/Yangudi1.jpg";
import Yangudi2 from "../../Assets/Image/destinations/Yangudi2.jpg";
import Yangudi3 from "../../Assets/Image/destinations/Yangudi3.jpg";

import lakegarmari from "../../Assets/Image/destinations/lakegarmari.jpg";



import awashriver1 from "../../Assets/Image/destinations/awashriver1.jpg";
import awashriver2 from "../../Assets/Image/destinations/awashriver2.jpg";
import awashriver3 from "../../Assets/Image/destinations/awashriver3.jpg";

import mountalid1 from "../../Assets/Image/destinations/mountalid1.jpg";
import mountalid2 from "../../Assets/Image/destinations/mountalid2.jpg";
import mountalid3 from "../../Assets/Image/destinations/mountalid3.jpg";
// List of destinations with correct image paths
const destinations = [
  {
    id: 1,
    title: "Danakil Depression",
    description:
      "A surreal landscape of colorful sulfur springs and salt flats, known for its extreme heat and unique geological features.",
    images: [danakil1, danakil2, danakil3], // Directly use imported images
  },
  {
    id: 2,
    title: "Erta Ale Volcano",
    description:
      "One of the world’s few permanent lava lakes, offering an awe-inspiring glimpse into Earth’s fiery core.",
    images: [ertale1, ertale2, ertale3], // Images added correctly
  },

  {
    id: 3,
    title: "Lake Afrera",
    description:
      " A stunning saltwater lake surrounded by dramatic volcanic landscapes, perfect for photography and exploration.",
    images: [afrera1, afrera2, afrera3], // Images added correctly
  },
  {
    id: 4,
    title: "Awash National Park",
    description:
      "A wildlife haven featuring diverse ecosystems, home to numerous species of birds, mammals, and stunning scenery.",
    images: [awash1, awash2, awash3], // Images added correctly
  },
  {
    id: 5,
    // Im
    title: "Hadar",
    description:
      ' An archaeological site renowned for its fossil discoveries, including the famous "Lucy" hominid.',
    images: [hadar1,hadar2, hadar3], //ages added correctly
  },
  {
    id: 6,
    title: "Mount Ayalu",
    description:
      " A striking volcanic mountain offering adventurous hikes and breathtaking views of the surrounding landscapes.",
    images: [mountayalu1], // Images added correctly
  },
  {
    id: 7,
    title: "The Greate Rift-Vally",
    description:
      "A dramatic geological formation with lakes, wildlife, and diverse cultures, ideal for exploration.",
    images: [riftvally1], // Images added correctly
  },
  {
    id: 8,
    title: "Lake Abbe",
    description:
      "A unique salt lake with otherworldly limestone chimneys, creating a mesmerizing desert landscape.",
    images: [lakeabbe1, lakeabbe2, lakeabbe3], // Images added correctly
  },
  {
    id: 9,
    title: "Yangudi Rassa National  Park",
    description:
      "A remote national park teeming with wildlife and rugged terrains, offering solitude and adventure.",
    images: [ Yangudi1,  Yangudi2,  Yangudi3], // Images added correctly
  },
  {
    id: 10,
    title: "Asaita & Lake Gamari",
    description:
      " A vibrant town near a picturesque lake, known for its cultural richness and beautiful scenery.",
    images: [lakegarmari],
  },
  {
    id: 11,
    title: "Awash River & Vally",
    description:
      "A lush river valley that supports diverse wildlife and lush vegetation amidst arid surroundings.",
    images: [awashriver1 , awashriver2 , awashriver3 ], // Images added correctly
  },
  {
    id: 12,
    title: "Mount Alid",
    description:
      " An impressive volcanic peak with dramatic landscapes, offering a challenging climb for adventurous visitors.",
    images: [mountalid1, mountalid2,mountalid3], // Images added correctly
  },
  // Add more destinations if needed...
];

const Destinations = () => {
  return (
    <div className="destination-page">
      {/* Banner Section */}
      <div className="banner-container">
        <img src={ertale2} alt="Afar Tourism" className="banner-image" />
        <div className="banner-caption">
          <h1>Explore the Wonders of Afar</h1>
          <p>A land of adventure, nature, and history.</p>
        </div>
      </div>

      {/* Destination Cards Section */}
      <div className="container mt-5">
        <div className="row">
          {destinations.map((destination) => (
            <div key={destination.id} className="col-md-4 mb-4">
              <div className="card">
                <Carousel>
                  {destination.images.map((img, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 card-img"
                        src={img}
                        alt={`Slide ${index + 1}`}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
                <div className="card-body">
                  <h5 className="card-title">{destination.title}</h5>
                  <p className="card-text">{destination.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Destinations;